import React, { createContext, useContext, useState, useMemo } from "react";

const TeamSupportContext = createContext(null);

export const TeamSupportProvider = ({ children }) => {
  const [supportInfo, setSupportInfo] = useState(null);
  const value = useMemo(() => ({ supportInfo, setSupportInfo }), [supportInfo]);
  return (
    <TeamSupportContext.Provider value={value}>
      {children}
    </TeamSupportContext.Provider>
  );
};

export const useTeamSupport = () => useContext(TeamSupportContext);
